export default __webpack_public_path__ + "static/media/acceZ.fa3f16e9.svg";